import type { InstallableModuleKey, WidgetKind } from "@playbookai/types";

/**
 * The module whose data a dashboard widget shows (ADR-0100). Every dashboard
 * host — Personal Home, VSM Home — reads this one map: "Add widget" leaves a
 * kind out while its module is off, and a widget already on the page asks for
 * no data and says the module is off instead. A kind absent here shows only
 * the host's own data and needs no other module.
 */
export const DASHBOARD_WIDGET_MODULE: Readonly<
  Partial<Record<WidgetKind, InstallableModuleKey>>
> = {
  mySolves: "solve",
  solveActions: "solve",
  myTasks: "solve",
  projectPulse: "solve",
  myVsms: "vsm",
  kaizenTable: "vsm",
  kaizenHealth: "vsm",
  strategicHealth: "hoshin",
  singleKpi: "kpi",
  chart: "kpi",
  kpiWatchlist: "kpi",
  kpiTable: "kpi",
};

/** The module a widget kind needs, or `null` when it needs none. */
export function dashboardWidgetModule(
  kind: string,
): InstallableModuleKey | null {
  return Object.hasOwn(DASHBOARD_WIDGET_MODULE, kind)
    ? (DASHBOARD_WIDGET_MODULE[kind as WidgetKind] ?? null)
    : null;
}
